var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',_vm._b({class:[_vm.rowClasses, {'frm-row': _vm.isFormMode, 'frm-row-noflex': !_vm.flex}]},'el-row',{gutter: _vm.gutter, justify: _vm.justify, align: _vm.align, type: _vm.type},false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }